/* eslint-disable max-len */
const moment = require('moment');

const _directiveDependencies = [];
const _controllerDependencies = ['$scope', '$interval', 'Util'];

class TimeCounterController {

    constructor($scope, $interval) {

        const endTimeParam = $scope.endtime;

        let intervalId;

        const transformToTwoDigitsNumber = number => (number < 10 ? '0' : '') + number;

        const formatTime = () => {

            const startTime = moment();
            const endTime = moment(...endTimeParam);
            const days = Math.floor(moment.duration(endTime.diff(startTime)).asDays());
            const hours = Math.floor(moment.duration(endTime.diff(startTime)).asHours()) - (days * 24);
            const minutes = Math.floor(moment.duration(endTime.diff(startTime)).asMinutes() - (((days * 24) + hours) * 60));
            const seconds = Math.floor(moment.duration(endTime.diff(startTime)).asSeconds() - (((days * 24 * 60) + (hours * 60) + minutes) * 60));

            if (days >= 0) {

                $scope.days = transformToTwoDigitsNumber(days);
                $scope.hours = transformToTwoDigitsNumber(hours);
                $scope.minutes = transformToTwoDigitsNumber(minutes);
                $scope.seconds = transformToTwoDigitsNumber(seconds);

            } else {

                $scope.days = '00';
                $scope.hours = '00';
                $scope.minutes = '00';
                $scope.seconds = '00';

            }

        };

        const onTick = () => {

            formatTime();

        };
        const init = () => {

            formatTime();

            $interval.cancel(intervalId);
            intervalId = $interval(onTick, 10 * 100);

        };

        $scope.$watch('endtime', init);

        $scope.$on('$destroy', () => {

            $interval.cancel(intervalId);

        });

    }

}


class TimeCounterDirective {

    constructor() {

        this.template = '<span>{{days}}:{{hours}}:{{minutes}}:{{seconds}}</span>';
        this.restrict = 'EA';
        this.replace = true;

        this.scope = {
            endtime: '=',
        };

        _controllerDependencies.push(($scope, $interval, Util) =>
            new TimeCounterController($scope, $interval, Util));
        this.controller = _controllerDependencies;
        this.controllerAs = 'TimeCounterCtrl';

    }

}

_directiveDependencies.push(() => new TimeCounterDirective());


angular.module('directives')
    .directive('timeCounter', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/time-counter.js